import React from 'react';

// Красивый спиннер загрузки. Используется на экране входа и на страницах,
// пока идут запросы к серверу/БД.
export default function Spinner({ label = 'Загрузка...' }) {
  return (
    <div className="spinner-wrap">
      <div className="spinner" aria-label={label} />
      {label && <div className="spinner-label">{label}</div>}
    </div>
  );
}
